import { apiRequest } from './api';
import { AtendimentoFigurinha } from '../types/atendimento';
import { ApiResponse } from '../types';

export interface AtendimentoFigurinhaCreateData {
  file?: File | null;
  media_url?: string | null;
  ativo: boolean;
  compartilhar: boolean;
}

export interface AtendimentoFigurinhaUpdateData {
  file?: File | null;
  ativo?: boolean;
  compartilhar?: boolean;
}

class AtendimentoFigurinhaService {
  private baseUrl = '/atendimento/figurinhas';

  async getAll(params?: {
    page?: number;
    limit?: number;
    activeOnly?: boolean;
    sharedOnly?: boolean;
  }): Promise<ApiResponse<AtendimentoFigurinha[]>> {
    return apiRequest.get<AtendimentoFigurinha[]>(this.baseUrl, { params });
  }

  async create(data: AtendimentoFigurinhaCreateData): Promise<ApiResponse<AtendimentoFigurinha>> {
    const formData = new FormData();
    if (data.file) formData.append('file', data.file);
    if (data.media_url) formData.append('media_url', data.media_url);
    formData.append('ativo', String(data.ativo));
    formData.append('compartilhar', String(data.compartilhar));

    return apiRequest.post<AtendimentoFigurinha>(this.baseUrl, formData);
  }

  async update(id: number, data: AtendimentoFigurinhaUpdateData): Promise<ApiResponse<AtendimentoFigurinha>> {
    const formData = new FormData();
    if (data.file) formData.append('file', data.file);
    if (data.ativo !== undefined) formData.append('ativo', String(data.ativo));
    if (data.compartilhar !== undefined) formData.append('compartilhar', String(data.compartilhar));

    return apiRequest.put<AtendimentoFigurinha>(`${this.baseUrl}/${id}`, formData);
  }

  async delete(id: number): Promise<ApiResponse> {
    return apiRequest.delete(`${this.baseUrl}/${id}`);
  }

  async send(ticketId: number, figurinhaId: number): Promise<ApiResponse> {
    return apiRequest.post(`${this.baseUrl}/${figurinhaId}/enviar`, { ticket_id: ticketId });
  }
}

export default new AtendimentoFigurinhaService();
